import { Fragment, HTMLAttributes } from 'react'

interface CoverLetterListItemPContentProps {
  content: string
  highlight?: string[]
  typographyProps?: HTMLAttributes<HTMLParagraphElement>
}

const CoverLetterListItemPContent = ({
  content,
  highlight,
  typographyProps,
}: CoverLetterListItemPContentProps) => {
  if (highlight && highlight.length > 0) {
    return (
      <>
        {highlight.map((item: string, index) => {
          return (
            <Fragment key={index}>
              <p
                dangerouslySetInnerHTML={{ __html: item }}
                {...typographyProps}
              />
            </Fragment>
          )
        })}
      </>
    )
  }
  return <p {...typographyProps}>{content}</p>
}

export default CoverLetterListItemPContent
